import * as React from 'react';
import { Alert } from 'rcd-cpp-ui/ui/alert/Alert';
import { useSelector } from '../../../utils/useSelector';
import { NodeType } from '../../../enums/NodeType';
import { getIntersection, getLockedNodeTypes } from '../../../utils';

export const CustomDataAlert = () => {
  const warningMsg = getWarningMsg();
  const isLocked = isDataLocked();

  if (isLocked) {
    return (
      <Alert className="metadata-validation-alert" type="warning">
        These fields have been locked by the System administrators. Contact
        <a href="mailto:cpphelp@gartner.com"> CPPHelp@gartner.com </a> if you
        have questions.
      </Alert>
    );
  }

  if (!!warningMsg) {
    return (
      <Alert className="metadata-validation-alert" type="warning">
        {warningMsg}
      </Alert>
    );
  }
  return null;
};

const isDataLocked = (): boolean =>
  useSelector(s => {
    const data = s.form?.data;
    const workspace = s.planning?.selectedWorkspace;
    if (!data?.labels || !data?.props || !workspace) return false;
    const lockedNodeTypes = getLockedNodeTypes(workspace);
    return getIntersection(data.labels, lockedNodeTypes).length > 0;
  });

const getWarningMsg = (): string =>
  useSelector(s => {
    const data = s.form?.data;
    if (!data?.labels || !data?.props) return null;
    const msg =
      'This item is in an invalid state. Cannot be set to web visible while inactive.';
    if (
      data.labels.includes(NodeType.RolePriority) ||
      data.labels.includes(NodeType.PriorityJourneyStep)
    ) {
      if (data.props.isWebVisible && !data.props.isActive) {
        return msg;
      }
    }
    if (data.labels.includes(NodeType.Position)) {
      if (data.props.isWebVisible && !data.props.isActive) {
        return msg;
      }
    }
    return null;
  });
